import { DashboardCard, PendingItem } from './types';

export const DEFAULT_DATE_RANGE_DAYS = 30;

export const FALLBACK_CARDS: DashboardCard[] = [
  {
    id: 'awaiting_acceptance',
    title: 'Aguardando Aceite',
    icon: 'acceptance',
    total: 0,
    color: 'cyan',
    countsByDate: [
      { label: 'Hoje', count: 0 },
      { label: 'Ontem', count: 0 },
      { label: 'Últimos 7 dias', count: 0 },
      { label: 'Mais de 7 dias', count: 0, isOld: false },
    ],
  },
  {
    id: 'awaiting_direction',
    title: 'Aguardando Direcionamento',
    icon: 'direction',
    total: 0,
    color: 'blue',
    countsByDate: [
      { label: 'Hoje', count: 0 },
      { label: 'Ontem', count: 0 },
      { label: 'Últimos 7 dias', count: 0 },
      { label: 'Mais de 7 dias', count: 0, isOld: false },
    ],
  },
  {
    id: 'in_progress',
    title: 'Em Andamento',
    icon: 'progress',
    total: 0,
    color: 'orange',
    countsByDate: [
      { label: 'Hoje', count: 0 },
      { label: 'Ontem', count: 0 },
      { label: 'Últimos 7 dias', count: 0 },
      { label: 'Mais de 7 dias', count: 0, isOld: false },
    ],
  },
  {
    id: 'awaiting_review',
    title: 'Revisões de Laudo',
    icon: 'review',
    total: 0,
    color: 'purple',
    countsByDate: [
      { label: 'Aguardando Prestadora', count: 0 },
      { label: 'Aguardando Banco', count: 0 },
      { label: 'Aguardando Inspetor', count: 0 },
      { label: 'Negado pelo Banco', count: 0 },
      { label: 'Devolvido Pós-Aceite', count: 0 },
    ],
  },
  {
    id: 'pending',
    title: 'Pendências',
    icon: 'warning',
    total: 0,
    color: 'red',
    countsByDate: [
      { label: 'Com pendências', count: 0 },
    ],
  },
  {
    id: 'completed',
    title: 'Concluído',
    icon: 'progress',
    total: 0,
    color: 'green',
    countsByDate: [
      { label: 'Hoje', count: 0 },
      { label: 'Ontem', count: 0 },
      { label: 'Últimos 7 dias', count: 0 },
      { label: 'Mais de 7 dias', count: 0, isOld: false },
    ],
  },
  {
    id: 'all_inspections',
    title: 'Inspeções',
    icon: 'review',
    total: 0,
    color: 'gray',
    countsByDate: [
      { label: 'Todas as inspeções', count: 0 },
    ],
  },
];

export const FALLBACK_PENDING_ITEMS: PendingItem[] = [];
